import React, { useState, useEffect, useRef} from 'react'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import './search.css'
import Bg from  '../../assets/slide4.jpg';
import Logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Link,useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import BackLoader from '../../components/backloader';
import { Button } from '@mui/material';

import * as Constants from '../../constants';
import { usePaystackPayment, PaystackConsumer } from 'react-paystack';


function Search() {

    const navigate = useNavigate();
    const {v1} = useParams();
    const {v2} = useParams();
    const {v3} = useParams();
    const {v4} = useParams();
    const {v5} = useParams();
    //const {uplineid} = useParams();
    const {type} = useParams();
    const {yr} = useParams();

    const {casenumber} = useParams();
    const {uplineid} = useParams();

 

    const [isLoading,setIsLoading]= useState(false);
    const [status, setStatus]=useState('initial');
    const [searchText, setSearchText]=useState('');
    const [config, setConfig]=useState({});
    const [isPayment, setIsPayment]=useState(false);
    const [pay, setPay] =useState({email:'',phone:'',name:''});


    const payconfig = {
        reference: (new Date()).getTime().toString(),
        // email: "user@example.com",
        // amount: 20000, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
        publicKey: Constants.paystack_public,
        callback_url:'http://localhost:3000/viewdocument'
    };
    
    // you can call this function anything
    const onSuccess = (reference) => {
      // Implementation for whatever you want to do with reference and after success call.
      console.log('success payment')
      console.log(reference);
    };
  
    // you can call this function anything
    const onClose = () => {
      // implementation for  whatever you want to do when the Paystack dialog closed.
      console.log('closed')
    }


  
   

    useEffect(() => {
        onConfig();
         var ss="";
         var b=false;
        if(v1!=null){
          ss=`${v1}/${v2}/${v3}/${v4}/${v5}` 
          b=true;
        }else if(type!=null){
        ss=`${casenumber}/${type}/${uplineid}` 
        b=true;
        }
         else{
          setSearchText('')
        }
        
        if(b){
          setSearchText(ss)
        onSearch(ss);
        }
        
       
      }, []);

      const onSearch= async(s)=>{
            console.log('search information '+s);
      
            var lsearch=s.replaceAll("/","-") ;
            const urls=`${Constants.apiUrl}/gazette/searchdocument/${lsearch}`;

            console.log(`the calling url ${urls}`);
            try {
                setIsLoading(true);
                const resp = await fetch(urls, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': '',
                  },
                });
                
                const data = await resp.json();
                setIsLoading(false);
                if(data.code==0){
                   
                    setStatus("success");
                }else{
                    setStatus("failed");
                }
                
              } catch (error) {
                setIsLoading(false);
                console.error(error);
                
              }   
      }

      const onConfig= async()=>{
        
        const urls=`${Constants.apiUrl}/gazette/getsettings`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            const data = await resp.json();
           setConfig(data);
            
          } catch (error) {
            console.error(error);
          }   
  }

    const onPay=(initializePayment)=>{
        var finalconfig={...payconfig, email: pay.email, phone:pay.phone, name:pay.name, amount:(config.verificationAmount*100) };
        console.log(finalconfig);
       
         initializePayment(onSuccess, onClose)
     
    }

  return (
    <div className='search-body'>
        <BackLoader open={isLoading}  />
        <img src={Bg} alt="Background" className='bg-image' />
      {!isPayment && <div className="wrapper">
            <img src={Logo} alt="Logo" style={{width:200}} />
            <div style={{backgroundColor:'#00000080', width:'100%', textAlign:'center', color:'white', marginTop:32, padding:32, borderRadius:12}}> <h1>Document/Affidavit Verification</h1> </div>
            <div className="search-bar">
                <input type="text" placeholder='Type document/affidavit reference number here for verification' value={searchText} onChange={(e)=> setSearchText(e.target.value)} />
                <FontAwesomeIcon icon={faSearch} />
            </div>
            <button className='red' style={{width:200, fontSize:16}} onClick={()=>onSearch(searchText)} >Search</button>
            <p style={{textAlign:'center'}}><a href='http://jisstaging.lagosjudiciary.gov.ng/index.html'>Return to Judiciary home</a></p>
         {status=='success' && <div className="results">
                <h3>Result found</h3>
                <div className="result">
                    <div className="result-name">
                        <p className='result-head'>Document/Affidavit Ref Found</p>
                        <p className="result-head"> To view/verify the document, you will be paying {Constants.formatCurrency (config.verificationAmount)}</p>
                    </div>
                    <Button className='red' onClick={()=> setIsPayment(true)}>Pay to access</Button>
                </div>
               
               
            </div>}   

            
            {status=='failed' && <div style={{backgroundColor:'white', padding:16}}> <p className="not-found">No results found. No Document/Affidavit with such reference number</p></div>}
        </div>}  
       {isPayment && <div className="wrapper">
        <img src={Logo} alt="Logo"  style={{width:200}} />
       <div style={{backgroundColor:'#00000080', width:'100%', textAlign:'center', color:'white', marginTop:32, padding:32, borderRadius:12}}> 
       <h1>Document({searchText}) Verification Payment</h1> </div>
       
            <div style={{backgroundColor:"#ffffff", alignItems:'center', textAlign:'center',display:'flex', flexDirection:'column', padding:16}}>
                <h2 style={{margin:16}}>This information is required for payment platform to be able to send payment receipt</h2>
                <form className='form-inp' action='/paystack.html'>
                    <input placeholder='Name' name="name" value={pay.name} onChange={(e)=> setPay({...pay, name:e.target.value}) } required />
                    <input placeholder='Email' name="email" value={pay.email} onChange={(e)=> setPay({...pay, email:e.target.value}) } required />
                    <input placeholder='Phone' name="phone" value={pay.phone} onChange={(e)=> setPay({...pay, phone:e.target.value}) } required />
                    <input type='hidden' name="amount" value={config.verificationAmount} />
                    <input type='hidden' name="docref" value={searchText} />
                    <input type='hidden' name="returnurl" value={`${Constants.baseurl}/payment/verifieddocument/`}   />
                    <h1>paying {Constants.formatCurrency (config.verificationAmount)}</h1>
                 <Button className='red' type='submit'>Pay Now</Button> 
                 </form>   
                
                
                
           
             {/*    <PaystackConsumer {...{...payconfig, email: pay.email, phone:pay.phone, name:pay.name, amount:(config.verificationAmount*100) }} >
                    {({initializePayment}) => <button className='red' style={{width:200}} onClick={()=>onPay(initializePayment)}>Pay Now</button>}
                    </PaystackConsumer> */}
            </div>

        </div>} 
    </div>
  )
}

export default Search